import getOfferPrice from "astrid-firestore/src/api/offers/utils/getOfferPrice";

import { useProfile } from "../../authentication/state/profile";

export default function useOfferPrice(offer) {
	const user = useProfile();

	return getOfferPrice({ offer, user });
}
